import React from 'react'
import '../styles/containerSection1.css'

function SectionComp1() {
    return (
        <div className='container_sectionmain container-xxl mt-5 pt-4 pb-4 mb-4'>
            <div className='col-lg-5 d-flex flex-column sectiona'>
                <h1 className='section1-tittle'>Asesórate con los mejores</h1>
                <h1 className='section1-tittle-2'>Protegerse no es una opción, es una <span className='fw-bold'>necesidad</span></h1>
                <p className='section1-tittle-3'> <span className='fw-bold section1-tittle-4'>En DEFIENDEME</span> Somos una firma de
                    servicios jurídicos profesionales dedicada a brindar
                    soluciones integrales para entidades y personas
                    naturales. Nuestro equipo está conformado por abogados
                    altamente calificados y especializados en todas las áreas
                    del derecho, garantizando un enfoque multidisciplinario
                    que abarca desde la asesoría preventiva, negocios
                    blindados jurídicamente hasta la defensa en procesos
                    judiciales</p>
            </div>

            <div className='containerSectionmain1'><img src={`${process.env.PUBLIC_URL}/img/abg/ClaribelCubillos.png`} alt="Descripción de la imagen" className="imagen-ajustada"></img>
            </div>

        </div>
    )
}

export default SectionComp1
